import React, { useContext } from 'react';
import { IconBlock, Icon } from 'anf-core-react';
import ESpotContent from '../ESpotContent/ESpotContent';
import ProductPageContext from '../../contexts/ProductPageContext';
import FindAStoreButton from './FindAStoreButton';
import tmntHelpers from '../../tools/tmntHelpers';
import TmntHtml from '../../tools/TmntHtml';

const getStoreIcon = (brand) => {
  let icon = 'storefront-hco';
  if (brand === 'anf' || brand === 'kids') icon = 'storefront-anf';
  return icon;
};

export default function OmniWdgetContent({
  activeProduct = '',
  selectedStore = '',
  sku = '',
  eSpotContentData,
  setFindAStoreModalOpen,
}) {
  const ProductPageState = useContext(ProductPageContext);
  const { tmntData, collectionData: { brand } } = ProductPageState;
  const storeIcon = getStoreIcon(brand);

  const getFreeStorePickupContent = () => {
    let storePickupContent = (
      <>
        {tmntData.omniStoreSize.value}
        {' '}
        <FindAStoreButton
          inline
          ctaLabel={tmntData.omniStoreActionAlt.value.toLowerCase()}
          setModalState={setFindAStoreModalOpen}
        />
      </>
    );
    if (sku && !selectedStore) {
      storePickupContent = <FindAStoreButton ctaLabel={tmntData.omniStoreActionAlt.value} setModalState={setFindAStoreModalOpen} />;
    } else if (!sku && selectedStore) {
      storePickupContent = (
        <>
          {tmntHelpers.replacePlaceholders(tmntData.omniStoreAvailability.value, { 0: selectedStore.name })}
          <FindAStoreButton
            ctaLabel={tmntData.omniStoreAction.value}
            setModalState={setFindAStoreModalOpen}
          />
        </>
      );
    } else if (sku && selectedStore) {
      storePickupContent = getQualifiedStorePickupContent();
    }
    return storePickupContent;
  };

  const getQualifiedStorePickupContent = () => {
    const fisAvailabilityMessage = getFISAvailabilityMessage();
    return (
      <>
        <div className="fis-availability-message">{fisAvailabilityMessage}</div>
        <div>{checkForPopinsMessage()}</div>
        <FindAStoreButton
          ctaLabel={tmntData.omniStoreAction.value}
          setModalState={setFindAStoreModalOpen}
        />
      </>
    );
  };

  const getFISAvailabilityMessage = () => {
    let availabilityMessage = tmntHelpers.replacePlaceholders(tmntData.omniStoreUnavailable.value, { 0: selectedStore.name });
    if (isAvailableToday()) {
      availabilityMessage = <TmntHtml value={tmntHelpers.replacePlaceholders(tmntData.omniStoreAvailable.value, { 0: selectedStore.name })} />;
    }
    return availabilityMessage;
  };

  const checkForPopinsMessage = () => {
    let popinsMessage = '';
    if (shouldDisplayPopinsAvailabilityMessage()) {
      popinsMessage = tmntData.omniStoreOrder.value;
    }
    return popinsMessage;
  };

  const isFisEligible = () => activeProduct?.fisEligibility
  && selectedStore?.fisEligibility;

  const isAvailableToday = () => isFisEligible()
      && selectedStore.inventory === 'available';

  const shouldDisplayPopinsAvailabilityMessage = () => !isFisEligible()
    && selectedStore?.popinsEligibility
    && activeProduct?.popinsEligibility
    && (selectedStore.inventory === 'available' || selectedStore.inventory === 'backorderable');

  const getHomeDeliveryContent = () => (
    <>
      <ESpotContent eSpotData={eSpotContentData?.Product_Free_Shipping} />
      {isAvailableToday() && activeProduct.courierEligibilityCode && (
      <div className="same-day-delivery">
        {tmntData.sameDayDelivery?.value}
      </div>
      )}
    </>
  );

  return (
    <section className="omni-content">
      <div className="free-store-pickup">
        <h3 className="free-store-pickup-header">
          <IconBlock centerVertically icon={(<Icon icon={storeIcon} size="s" />)}>
            {tmntData.omniStoreTitle.value}
          </IconBlock>
        </h3>
        <div className="free-store-pickup-content" data-testid="free-store-pickup-content">
          {getFreeStorePickupContent()}
        </div>
      </div>
      <div className="home-delivery">
        <h3 className="home-delivery-header">
          <IconBlock centerVertically icon={(<Icon icon="shipping" size="s" />)}>
            {tmntData.homeDelivery?.value}
          </IconBlock>
        </h3>
        <div className="home-delivery-content" data-testid="home-delivery-content">
          {getHomeDeliveryContent()}
        </div>
      </div>
    </section>
  );
}
